import React, { useContext } from 'react';
import { Row, Col, Space, Card, Typography } from 'antd';
import './scss/embed-on-site.scss';
import ChatBotContext from 'hooks/chat-bot-context';

const { Text, Paragraph } = Typography;

const EmbedOnSite = () => {
  const { selectedBot } = useContext(ChatBotContext);

  const scriptToEmbedOnSite = `
        <div id="root" data-chatbotId="${selectedBot}" style="width: 0px; height: 0px; overflow: hidden"></div>
        <script src="${process.env.REACT_APP_WIDGET_BASE_URL}embed.js"></script>
        <link rel="stylesheet" href="${process.env.REACT_APP_WIDGET_BASE_URL}embed.css"></link>`;
  return (
    <div>
      <h2>Add bot to your site</h2>
      <Row>
        <Col span={18}>
          <Space size='middle' direction='vertical' style={{ display: 'flex' }}>
            <Card>
              <Text>To add a chat bubble at the bottom right of your website add this script tag to your html</Text>

              <Paragraph className='codeContainer' type='info'>
                <pre>
                  <Text copyable>{scriptToEmbedOnSite}</Text>
                </pre>
              </Paragraph>
            </Card>
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default EmbedOnSite;
